import React, { useEffect, useState } from "react";
import { formatPhoneNumberToE164 } from "../utls/utils";
import TamaguiInput, { TamaguiInputProps } from "./tamagui-input";

export interface PhoneInputProps
  extends Omit<TamaguiInputProps, "onChangeText" | "value"> {
  value: string;
  onChangeText?: (value: string) => void;
}

const PhoneInput = React.forwardRef<any, PhoneInputProps>(
  ({ value, onChangeText, ...props }, ref) => {
    const formatDigits = (digits: string) => {
      if (!digits || digits.length === 0) {
        return "";
      }
      const d = digits.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
      const part1 = d.slice(0, 3);
      const part2 = d.slice(3, 6);
      const part3 = d.slice(6, 10);
      let formatted = "";
      if (part1) {
        formatted += `(${part1}`;
      }
      if (d?.length >= 4) {
        formatted += `) ${part2}`;
      } else if (d.length > 3) {
        formatted += `)`;
      }
      if (d?.length >= 7) {
        formatted += `-${part3}`;
      }
      return formatted;
    };

    const [displayValue, setDisplayValue] = useState<string>(
      formatDigits(value)
    );

    useEffect(() => {
      setDisplayValue(formatDigits(value));
    }, [value]);

    const handleChange = (text: string) => {
      if (!text) {
        setDisplayValue("");
        if (onChangeText) {
          onChangeText("");
        }
        return;
      }
      const digits = text?.replace(/\D/g, "").slice(0, 10);
      const human = formatDigits(digits);
      setDisplayValue(human);
      if (onChangeText) {
        onChangeText(formatPhoneNumberToE164(digits));
      }
    };

    return (
      <TamaguiInput
        ref={ref}
        {...props}
        value={displayValue}
        onChangeText={handleChange}
      />
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
